'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useStore } from '@mui/x-internals/store';
import { useChatLocaleText } from "../chat/internals/ChatLocaleContext.js";
import { chatSelectors } from "../selectors/index.js";
import { useChatStore } from "./useChatStore.js";
export function useMessageAuthor(messageId) {
  const store = useChatStore();
  const localeText = useChatLocaleText();

  // Inject locale-driven role display names into the resolver parameters so the
  // fallback when no author signal is available reflects the active locale.
  const parametersWithLocale = React.useMemo(() => _extends({}, store.parameters, {
    roleDisplayNames: _extends({
      user: localeText.messageAuthorUserLabel,
      assistant: localeText.messageAuthorAssistantLabel,
      system: localeText.messageAuthorSystemLabel
    }, store.parameters.roleDisplayNames)
  }), [store.parameters, localeText.messageAuthorUserLabel, localeText.messageAuthorAssistantLabel, localeText.messageAuthorSystemLabel]);
  return useStore(store, chatSelectors.messageAuthor, messageId, parametersWithLocale);
}